export default "__VITE_ASSET__Bc_l4CqH__"